module.exports = __webpack_public_path__ + "img/colour_design_splash.cf698858.jpg";